/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let CommsThread = React.lazy(() => import('DesignSystem/CommsThread/index'))



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsOverlay/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let constantData = '- Patient'
let commsThreadIdValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'thread_id',
})
let commsIsSecureValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'is_secure',
})
let commsAutoUploadedAttachmentsValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'auto_uploaded_attachments',
})
let commsMessageValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'message',
})
let commsTagsValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'tags',
})
let constantData1 = 'Please find the attachments included for'
let commsPersonValueData = fromData.useDataFormat({ viewPath,
context: 'comms',
path: 'person',
format: fromFormat.patientName,
})
let aggregateData = fromAggregate.join(constantData1, commsPersonValueData)
let commsMessageComposesValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'message_composes',
})
let commsThreadIdsHackValueData = fromData.useDataValue({ viewPath,
context: 'comms',
path: 'thread_ids_hack',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let onThreadIdsHackChange = fromHelpers.useOnThreadIdsHackChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--b-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--l-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-3-Z1Yf8zk': dtColorsWhite,'--bblr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-8-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<SentryErrorBoundary
{...childProps}
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<React.Fragment>
<CloseAction
{...childProps}
  viewPath={`${viewPath}/CloseAction`}
/>
<CommsThread
{...childProps}
  viewPath={`${viewPath}/CommsThread`}
 data="comms.person"
 format="/Data/format.js patientName"
 data="'- Patient'"
 thread_name={undefined}
 data="comms.thread_id"
 thread_id={commsThreadIdValueData}
 data="comms.is_secure"
 is_secure={commsIsSecureValueData}
 data="comms.auto_uploaded_attachments"
 auto_uploaded_attachments={commsAutoUploadedAttachmentsValueData}
 data="comms.message"
 message={commsMessageValueData}
 data="comms.tags"
 tags={commsTagsValueData}
 data="'Please find the attachments included for'"
 data="comms.person"
 format="/Data/format.js patientName"
 aggregate="/Simple/Data/aggregate.js join"
 attachments_message={aggregateData}
 onSubmit={onSubmit}
 data="comms.message_composes"
 message_composes={commsMessageComposesValueData}
 data="comms.thread_ids_hack"
 thread_ids_hack={commsThreadIdsHackValueData}
 onChange={onChange}
 onThreadIdsHackChange={onThreadIdsHackChange}
/>
</React.Fragment>
)}
</SentryErrorBoundary>
)}
</SuspenseBoundary>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}